const calcAverage = (items, field) => {
	let sum = 0;
	for (const item of items) {
		sum += item[field];
	}
	return sum / items.length;
};

const calcVectorLength = (x, y, z) => Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2));
const calcVectorDiffLength = (x0, y0, z0, x1, y1, z1) => calcVectorLength(x0 - x1, y0 - y1, z0 - z1);

const calcAverageVector = (coords) => {
	let avgVector = {};
	for (const field of ['x_coord', 'y_coord', 'z_coord']) {
		avgVector[field] = calcAverage(coords, field);
	}
	return avgVector;
};

const calcStdVector = (coords, avgVector) => {
	if (coords.length === 0) {
		return {
			x_coord: 0,
			y_coord: 0,
			z_coord: 0,
		}
	}
	if (coords.length === 1) {
		return {
			x_coord: coords[0].std,
			y_coord: 0,
			z_coord: 0,
		}
	}
	let result = {
		x_coord: 0,
		y_coord: 0,
		z_coord: 0,
	};
	for (const coord of coords) {
		result.x_coord += Math.pow(coord.x_coord - avgVector.x_coord, 2);
		result.y_coord += Math.pow(coord.y_coord - avgVector.y_coord, 2);
		result.z_coord += Math.pow(coord.z_coord - avgVector.z_coord, 2);
	}
	result.x_coord = Math.sqrt(result.x_coord / (coords.length - 1));
	result.y_coord = Math.sqrt(result.y_coord / (coords.length - 1));
	result.z_coord = Math.sqrt(result.z_coord / (coords.length - 1));
	return result;
};

export default {
	calcAverage,
	calcAverageVector,
	calcVectorLength,
	calcVectorDiffLength,
	calcStdVector,
}
